import { useEffect } from "react";
import { toast } from "sonner";

const bundle = (html) => (html.match(/static\/js\/main\.[\w]+\.js/) || [])[0];

// Open tabs / installed app keep running an old build after a deploy; offer a one-tap refresh.
export const UpdateWatcher = () => {
  useEffect(() => {
    const mine = bundle(document.documentElement.innerHTML);
    if (!mine) return undefined;
    let shown = false;
    const check = async () => {
      if (shown || document.visibilityState !== "visible") return;
      try {
        const html = await (await fetch(`/?v=${Date.now()}`, { cache: "no-store" })).text();
        const live = bundle(html);
        if (live && live !== mine) {
          shown = true;
          toast("يوجد تحديث جديد لرواج الذكية", {
            duration: Infinity,
            action: { label: "تحديث الآن", onClick: () => window.location.reload() },
          });
        }
      } catch { /* offline */ }
    };
    const t = setInterval(check, 120000);
    document.addEventListener("visibilitychange", check);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", check); };
  }, []);
  return null;
};
